import {
	FormDrawerContentProps,
	I18nFormDrawerContent,
	I18nOnlyOnMainForm,
	I18nSlateTextInputField,
	TextField,
} from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { OrganizerFormValues, OrganizerTranslationEntry } from "../types/organizer";
import { OrganizerTypeSingleSelectField } from "./OrganizerTypeSingleSelectField";

export const useValidateOrganizer = () => {
	const { t } = useTranslation();

	return (values: OrganizerFormValues) => {
		const errors: { [K in keyof OrganizerFormValues]?: any } = {};
		if (!values.name) {
			errors.name = t("Required field");
		}
		if (!values.type) {
			errors.type = t("Required field");
		}
		return errors;
	};
};

const emptyTranslation: OrganizerTranslationEntry = { description: [{ type: "paragraph", children: [{ text: "" }] }] };

export const OrganizerFormDrawerContent: FC<FormDrawerContentProps> = (props) => {
	const { t } = useTranslation();

	return (
		<I18nFormDrawerContent {...props} emptyTranslation={emptyTranslation}>
			<I18nOnlyOnMainForm>
				<TextField name="name" label={t("Name")} required={true} />
				<OrganizerTypeSingleSelectField name="type" label={t("Type")} required={true} />
			</I18nOnlyOnMainForm>
			<I18nSlateTextInputField name="description" label={t("Description")} />
		</I18nFormDrawerContent>
	);
};
